import ClipLoader from "react-spinners/ClipLoader";

const Loader = ({ loading }) => {
  if (!loading) return null;

  return (
    <div style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(255,255,255,0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    }}>
      <ClipLoader size={70} color="#67c6a9" />
    </div>
  );
};



export default Loader
